export function Alerts() {
    return <div>
        Alerts
    </div>
}